import { BadgeCheck, Bot, ClipboardCheck, Code2, FileSearch, Gauge, Link2, MapPin, QrCode } from 'lucide-react';

/* Free tool catalog. `kind` drives how the card links:
   - 'tool'  -> internal working tool at /free-tools/:slug
   - 'scan'  -> anchors to the visibility scan console
   - 'account' -> requires a free account (dashboard) */
export const FREE_TOOLS = [
  {
    slug: 'visibility-scan', kind: 'scan', icon: Gauge,
    name: 'Website Visibility Scan', tagline: 'Score any site on seven local-search signals',
    blurb: 'Run a live check of any local business website and see exactly which local-search signals are missing.',
  },
  {
    slug: 'schema-generator', kind: 'tool', icon: Code2,
    name: 'Local Schema Generator', tagline: 'Create LocalBusiness structured data',
    blurb: 'Fill in your business details and get copy-ready JSON-LD schema that helps Google and AI engines understand you.',
  },
  {
    slug: 'utm-builder', kind: 'tool', icon: Link2,
    name: 'Campaign Link Builder', tagline: 'Track every marketing link',
    blurb: 'Build clean, tagged tracking links so you always know which post, email, or ad produced a lead.',
  },
  {
    slug: 'review-link', kind: 'tool', icon: QrCode,
    name: 'Google Review Link Builder', tagline: 'A direct "leave a review" link',
    blurb: 'Turn your Google Place ID into a one-tap review link you can text customers or print on receipts.',
  },
  {
    slug: 'local-seo-checklist', kind: 'tool', icon: ClipboardCheck,
    name: 'Local SEO Checklist', tagline: 'The plain-English audit for owners',
    blurb: 'Walk through the 18 things that actually move local rankings and see your readiness score as you go.',
  },
  {
    slug: 'meta-check', kind: 'scan', icon: FileSearch,
    name: 'Meta & Schema Check', tagline: 'Title, description, and markup review',
    blurb: 'Check whether your title, meta description, headings, and structured data are set up for search.',
  },
  {
    slug: 'ai-visibility', kind: 'scan', icon: Bot,
    name: 'AI Visibility Checker', tagline: 'See if AI search engines know you',
    blurb: 'Confirm the structured signals AI assistants rely on to recommend your business are actually present.',
  },
  {
    slug: 'rank-checker', kind: 'account', icon: MapPin,
    name: 'Local Rank Checker', tagline: 'Check rankings from anywhere',
    blurb: 'Record where you appear in Maps and Search by keyword and market, then track it over time.',
  },
];

export const TOOL_SLUGS = new Set(FREE_TOOLS.filter(tool => tool.kind === 'tool').map(tool => tool.slug));

export const findTool = slug => FREE_TOOLS.find(tool => tool.slug === slug);

export const CATEGORY_META = { BadgeCheck };
